/**
 * Golden State Lumber logos from the brand package (public/brand). The primary version is for light
 * surfaces; the "alt" version (white wordmark) is for dark ones, per the brand guidelines. Both are
 * rendered and the theme attribute on <html> decides which is visible.
 */
export function BrandLogo({
  variant,
  className = '',
  alt = 'Golden State Lumber',
}: {
  variant: 'horizontal' | 'stacked' | 'brandmark';
  className?: string;
  alt?: string;
}) {
  if (variant === 'brandmark') {
    return <img src="/brand/gsl-brandmark.svg" alt={alt} className={className} draggable={false} />;
  }
  const light = `/brand/gsl-${variant}.svg`;
  const dark = `/brand/gsl-${variant}-dark.svg`;
  return (
    <>
      <img src={light} alt={alt} className={`gsl-logo-light ${className}`} draggable={false} />
      <img src={dark} alt="" aria-hidden="true" className={`gsl-logo-dark ${className}`} draggable={false} />
    </>
  );
}
